import { render } from "./DishInfoComponent.vue?vue&type=template&id=9527b482&scoped=true"
import script from "./DishInfoComponent.vue?vue&type=script&lang=js"
export * from "./DishInfoComponent.vue?vue&type=script&lang=js"

import "./DishInfoComponent.vue?vue&type=style&index=0&id=9527b482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9527b482"]])

export default __exports__